var React = require('react');

function PaginationRightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M60 120V0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120ZM34.5858 70.5858C33.8047 71.3668 33.8047 72.6332 34.5858 73.4142C35.3668 74.1953 36.6332 74.1953 37.4142 73.4142L49.4142 61.4142C49.7893 61.0391 50 60.5304 50 60C50 59.4696 49.7893 58.9609 49.4142 58.5858L37.4142 46.5858C36.6332 45.8047 35.3668 45.8047 34.5858 46.5858C33.8047 47.3668 33.8047 48.6332 34.5858 49.4142L43.4216 58.25H20C18.8954 58.25 18 59.1454 18 60.25C18 61.3546 18.8954 62.25 20 62.25H42.9216L34.5858 70.5858Z","fill":"white","fillOpacity":"0.5"}));
}

PaginationRightArrow.defaultProps = {"width":"60","height":"120","viewBox":"0 0 60 120","fill":"none"};

module.exports = PaginationRightArrow;

PaginationRightArrow.default = PaginationRightArrow;
